module.exports = __webpack_public_path__ + "img/AvgScore.aed1a819.svg";